const makeInitialState = (values) => {
  return {
    contract: values.contract || null
  };
};

export default makeInitialState;
